import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback, useEffect, useRef } from 'react';
import { getUserSelectedAccountType } from '../../../app/appSelectors';
import { logAppsflyerAction } from '../../../app/appActions';
import { LOG_AF_EVENT_NAMES } from '../../../app/appConstants';
import { MobileRouterPaths } from '../../mobileAppConstants';
import appHistory from '../../../app/appHistory';
import { getPayoutParamsAction } from '../../../modules/Withdrawal/withdrawalReducer';
import MobilePortfolioContent from './MobilePortfolioContent/MobilePortfolioContent';

function MobilePortfolio() {
    const prevAccountType = useRef(null);
    const selectedAccountType = useSelector(getUserSelectedAccountType);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPayoutParamsAction());
    }, [dispatch]);

    useEffect(() => {
        if (selectedAccountType && !prevAccountType.current) {
            dispatch(logAppsflyerAction({
                name: LOG_AF_EVENT_NAMES.MAIN_SHOWN,
                payload: { account_type: selectedAccountType },
            }));
        }
        prevAccountType.current = selectedAccountType;
    }, [dispatch, selectedAccountType]);

    const handleSelectAsset = useCallback((e) => {
        e.preventDefault();
        appHistory.push(MobileRouterPaths.market);
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_SELECT_ASSET,
            payload: { account_type: selectedAccountType, source: 'select' },
        }));
    }, [dispatch, selectedAccountType]);

    const handleSelectPosition = useCallback((selectedPosition) => {
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_POSITION,
            payload: {
                account_type: selectedAccountType,
                asset: selectedPosition.symbol,
                position_code: selectedPosition.positionCode,
            },
        }));
    }, [dispatch, selectedAccountType]);

    const handleSelectOrder = useCallback((selectedOrder) => {
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_ORDER,
            payload: {
                account_type: selectedAccountType,
                asset: selectedOrder.instrument,
                order_code: selectedOrder.orderCode,
                order_type: selectedOrder.type,
            },
        }));
    }, [dispatch, selectedAccountType]);

    return <MobilePortfolioContent
        handleSelectAsset={handleSelectAsset}
        handleSelectPosition={handleSelectPosition}
        handleSelectOrder={handleSelectOrder}
    />;
}

export default MobilePortfolio;
